export class AnalysisCard {
  constructor(data) {
    this.data = data
    this.results = []
    this.bank = null
    this.user = null
  }

  compare(a, b) {
    if (a.date < b.date) {
      return -1;
    }
    if (a.date > b.date) {
      return 1;
    }
    return 0;
  }

  parseData() {
    Object.entries(this.data).map(([key, prop], index) => {
      if (!Number.isNaN(parseInt(key))) {
        this.results.push({
          date: key,
          value: prop
        })
      } else if(key === 'bank') {
        this.bank = prop
      } else if (key === 'holder_name') {
        this.user = prop
      }
    })
    this.results.sort(this.compare)
  }


}